export default "__VITE_ASSET__yy_IxNmf__"